// Third party
import React from 'react';

// Proposal
import * as ProposalNS from '../../../Proposal';

// Utils
import { formatLocalizedString } from '@/utils/i18n/i18n';

// Components
import { Checkbox } from '@/views/components/inputs';
import InfoTooltip from '@/views/components/tooltips/InfoTooltip';

type DivisionTitleProps = {
  division: ProposalNS.ProposalTemplateDivisionElement;
  selectedDivisions: string[];
  disabled?: boolean;
  sidebarTooltip?: ProposalNS.SidebarTooltip;
  toggleDivision: (division: string, selected: boolean) => void;
  overrideTooltipPosition?: (coords: { left: number; top: number }) => { left: number; top: number };
};

const DivisionTitle = ({ division, selectedDivisions, disabled, sidebarTooltip, toggleDivision, overrideTooltipPosition }: DivisionTitleProps) => {
  const divisionIsSelected = (divisionKey: string): boolean => selectedDivisions.indexOf(divisionKey) > -1;

  if (division.sidebarControl === ProposalNS.ProposalSidebarControl.Checkbox) {
    return (
      <>
        <Checkbox
          selected={divisionIsSelected(division.key)}
          onChange={checked => toggleDivision(division.key, checked)}
          label={formatLocalizedString(division.label)}
          disabled={disabled}
        />

        {sidebarTooltip && (
          <InfoTooltip
            title={formatLocalizedString(sidebarTooltip.title)}
            message={formatLocalizedString(sidebarTooltip.message)}
            overridePosition={overrideTooltipPosition}
          />
        )}
      </>
    );
  }

  if (!division.label) {
    return null;
  }

  return (
    <h3 className="proposal-division-title">
      {formatLocalizedString(division.label)}
      {sidebarTooltip && (
        <InfoTooltip
          title={formatLocalizedString(sidebarTooltip.title)}
          message={formatLocalizedString(sidebarTooltip.message)}
          overridePosition={overrideTooltipPosition}
        />
      )}
    </h3>
  );
};

export default DivisionTitle;
